import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function toBeWithin(startValue: number, endValue: number, errorText: string = ''): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentValue = control.value as number;

    if (!(currentValue >= startValue && currentValue <= endValue)) {
      return {
        description: errorText,
        code: '300',
      };
    }
    return null;
  };
}
